import React from "react";
import { WidgetProvider } from "@/context/widget-provider";
import { useWidgets } from "@/hooks/use-widgets";
import { IGNORED_ROOT_WIDGET_IDS } from "@/constants";
import WidgetLoader from "./components/widget/widget-loader";
import WidgetCardSkeleton from "./components/widget/widget-card-skeleton";

const Widgets: React.FC = () => {
  const { data: widgets, isError, isLoading } = useWidgets();

  const excludedWidgetsSet = new Set(
    IGNORED_ROOT_WIDGET_IDS.map((widget) => widget.rootWidgetId),
  );

  if (isLoading)
    return [...Array(5)].map((_, i) => (
      <WidgetCardSkeleton key={`widget-${i}`} />
    ));

  if (isError || !Array.isArray(widgets) || widgets?.length === 0) {
    return <></>;
  }

  return (
    <WidgetProvider>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        {widgets
          ?.filter((widget) => !excludedWidgetsSet.has(widget.rootWidgetId))
          .map((widget) => {
            return (
              <WidgetLoader
                key={`${widget.rootWidgetId}-${widget.widgetId}`}
                widget={widget}
              />
            );
          })}
      </div>
    </WidgetProvider>
  );
};

export default Widgets;
